// extracted by mini-css-extract-plugin
export default {"card":"card_card__RFS8o","controls":"card_controls__Brwip","postLink":"card_postLink__h+8U4","actions":"card_actions__TmbwL"};